module.exports = __webpack_public_path__ + "img/shat-pin-icon-green.abcf81c0.svg";